import { useEffect, useState } from 'react';

interface zipcodeData {
  [key: string]: {
    address: {
      adminDistrict: string;
      adminDistrict2: string;
      countryRegion: string;
      formattedAddress: string;
      locality: string;
      postalCode: string;
    };
    confidence: string;
    coordinates: number[];
  };
}
export const useZipcodeData = (zipcode: string, errorText: string) => {
  const url = '/platform/api/v1/address/citystate';
  const [result, setResult] = useState<string | null>(null);
  const [coordinates, setCoordinates] = useState<{
    latitude: number;
    longitude: number;
  }>();
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const resp = await fetch(`${url}/${zipcode}`);
      const data: zipcodeData = await resp.json();
      const zipData = data && data[zipcode] ? data[zipcode] : undefined;
      const result =
        zipData &&
        zipData.address &&
        zipData.address.countryRegion === 'United States' &&
        zipData.confidence === 'High';
      if (result) {
        setResult(zipcode);
        setCoordinates({
          latitude: data[zipcode].coordinates[0],
          longitude: data[zipcode].coordinates[1],
        });
        setError(null);
      } else {
        setResult(null);
        setError(errorText);
      }
    } catch (e) {
      setResult(null);
      setError(errorText);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zipcode]);

  return { result, error, isLoading, coordinates, fetchData };
};
